import { GroupBase, StylesConfig } from "react-select";

import { BasicOption } from "@/modules/form/components/SelectInput/SelectInput";
import { grey, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

type ReactStylesConstructor = <
  Option extends BasicOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: Theme
) => StylesConfig<Option, IsMulti, Group>;

export const createGroupPickerStyles: ReactStylesConstructor = ({
  palette,
  typography,
  boxShadows,
  spacing,
}) => {
  return {
    menu: (provided) => ({
      ...provided,
      marginTop: 0,
      boxShadow: boxShadows.dropdown,
      maxWidth: 200,
    }),
    valueContainer: (provided) => ({
      ...provided,
      lineHeight: "normal",
      padding: spacing([0.25, 0, 0.25, 1]),
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    control: (provided) => ({
      ...provided,
      minHeight: 30,
      width: 135,
      borderRadius: 15,
      display: "inline-flex",
      color: palette.secondary.textDark,
      fontFamily: typography.fonts.body,
      fontWeight: typography.fontWeight.medium,
      fontSize: typography.fontSize.small,
      cursor: "pointer",
      border: 0,
      boxShadow: "none",
      backgroundColor: grey[100],
    }),
    placeholder: (provided) => ({
      ...provided,
      fontWeight: typography.fontWeight.medium,
      color: grey[500],
    }),

    dropdownIndicator: (provided) => ({
      ...provided,
      padding: spacing(0.625),
      marginRight: spacing(0.625),
      transform: "scale(0.7)",
      color: palette.default.text,
      "&:hover": {
        color: "inherit",
      },
    }),
    option: (provided, { isSelected, isFocused }) => ({
      ...provided,
      position: "relative",
      padding: spacing([1.5, 2]),
      backgroundColor: isSelected || isFocused ? grey[0] : white,
      color: palette.secondary.textDark,
      fontWeight: typography.fontWeight.medium,
      cursor: "pointer",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      paddingRight: spacing(5),
      "&:hover, &:active, &:focus": {
        backgroundColor: grey[0],
      },
      "&:after": {
        content: '""',
        position: "absolute",
        width: spacing(1),
        height: spacing(0.75),
        right: spacing(2),
        top: "calc(50% - 3px)",
        transform: "translateY(-50%) rotate(-45deg)",
        display: isSelected ? "block" : "none",
        borderBottom: `2px solid ${palette.tertiary.text}`,
        borderLeft: `2px solid ${palette.tertiary.text}`,
      },
    }),
  };
};
